module.exports = __webpack_public_path__ + "media/images/e-kvitok/CARD-f2c79af792cbb1e5a8ac82a995735fab.svg";